import { SystemField } from "./system-field";

export class ShipmentDetail extends SystemField {
     
     qty?:number;
     sale_order_details_id?:string;
     shipments_id?:string;
     sales_order_id?:string;
     ship_qty?:number;
     uom_id?:string;
     prev_shipped_qty?:number;
     prev_open_qty?:number;
     is_direct_create?:number;
}
